export default __webpack_public_path__ + "static/media/replay_10_black_48dp.47fd77c3.svg";